import { get } from "lodash";
import { memo, useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";

import AddBudget from "./AddBudget.js";
import {
  deleteBudget,
  getByIdBudget,
  getListBudget,
  // getCountBudget,
  setAlertError,
} from "./BudgetSlice.js";
import { formatDateString, isPastFiscalYear } from "./Constant.js";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import DetailTable from "../../../../app/common-components/DetailTable/Index.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData.jsx";
import CommonBtn from "../../../../app/common-components/ui-components/Button/Index.jsx";
import { convertEpochToDate, formatAsDollar, useCommonAlert } from "../../../../app/utilities/helpers.js";

// import {RoleConfig,filterDataHeader} from "../../../common/RoleConfig.js";


const BudgetDetails = ({ aorPayload, actionRBAO }) => {
  const dispatch = useDispatch();
  const { common } = useSelector((state) => state);
  const { userName, userRole } = common.loggedUser;
  let { getCmdbId } = useSelector((state) => state.cmdbId);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const {
    ListLoadingBudget,
    deleteLoadingBudget,
    CountBudget,
    ListBudget,
    error,
  } = useSelector((state) => state.BudgetApi);
  const pageNo = get(common, "completeTable.pageNo", []);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState("");

  const [listPayload, setlistPayload] = useState({});
  const [state, setState] = useState({
    modalOpen: false,
    currentAction: '',
    deleteModal: false,
    deletepayload: {},
    infoModal: false,
    infopayload: {},
    alert: false,
    alertType: "",
    alertMessage: "",
  });
  useEffect(() => {
    // dispatch(
    //   getCountBudget({cmdbId:getCmdbId, payload: {keyword: searchInputValue } })
    // );
    // dispatch(getFyList(getCmdbId));
    const Payload = {
      cmdbId: getCmdbId,
      pageNumber: currentPageNo,
      itemsPerPage: pageLimit,
      payload: { keyword: searchInputValue },
    };
    setlistPayload(Payload);
    dispatch(getListBudget(Payload));
  }, [pageLimit, currentPageNo, searchInputValue]);

  useEffect(() => {
    if (error) {
      callCommonAlert("error", "Something went wrong. Please try again.");
      hideCommonAlert();
      dispatch(setAlertError());
    }
  }, [error]);

  // useEffect(() => {
  //   if (deleteDataCB != "") {
  //     callAlert(deleteDataCB);
  //   }
  // }, [deleteDataCB]);
  const callAlert = (data) => {
    const message = data.body;
    if (data.statusCodeValue === 200) {
      setCurrentPageNo(0);
      setSearchInputValue("");
      callCommonAlert("success", message);
      hideCommonAlert();
      // dispatch(
      //   getCountBudget({cmdbId:listPayload.cmdbId,payload:listPayload.payload})
      // );
      dispatch(getListBudget(listPayload));
      //   dispatch(
      //     getCountAOR({payload:aorPayload.payload,cmdbId:getCmdbId})
      //   );
      //   dispatch(getListAOR(aorPayload));
    } else if (data.statusCodeValue === 204) {
      setCurrentPageNo(0);
      setSearchInputValue("");
      callCommonAlert("warning", message);
      hideCommonAlert();
      // dispatch(
      //   getCountBudget({cmdbId:listPayload.cmdbId,payload:listPayload.payload})
      // );
      dispatch(getListBudget(listPayload));
      //   dispatch(
      //     getCountAOR({payload:aorPayload.payload,cmdbId:getCmdbId})
      //   );
      //   dispatch(getListAOR(aorPayload));
    } else {
      callCommonAlert("error", message);
      hideCommonAlert();
    }
  };
  const deleteCall = (deleteId) => {
    dispatch(deleteBudget(deleteId)).then((data) => {
      deletehandleClose();
      callAlert(data.payload);
    });
  };
  const dataheader = [
    {
      Header: "Sl.No ",
      className: "text-center noSort",
      disableSortBy: true,
      accessor: "1",
      tdClassName: "text-center",
      isTooltip: "Serial Number",
      Cell: ({ row }) => {
        const serialNumber = row.index + 1;
        return <>{serialNumber}</>;
      },
    },

    {
      Header: "Financial Year",
      accessor: "financialYear",
      className: "text-start noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "webKitCenter",
      isTooltip: "The fiscal year to which the budget applies.",
    },
    {
      Header: "Opex ID",
      accessor: "opexId",
      className: "text-start noSort",
      tdClassName: "webKitCenter",
      thClassName: "text-center",
      colSpan: 2,
      rowSpan: 2,
      disableSortBy: true,
      isTooltip: "Unique identifier for the operational expense record.",
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "Effective Date",
      accessor: "effectiveDate",
      className: "text-start noSort",
      thClassName: "text-center",
      tdClassName: "webKitCenter",
      disableSortBy: true,
      isTooltip: "The date from which the budget becomes active.",
      Cell: ({ value }) => {
        return (
          <td className={`text-center`}>
            {value ? formatDateString(value) : "-"}
          </td>
        );
      },
    },

    {
      Header: "Allocated Budget",
      accessor: "allocatedBudget",
      className: "text-center noSort",
      tdClassName: "text-left",
      thClassName: "text-center",
      disableSortBy: true,
      isTooltip: "Total budget assigned for the selected period.",
      Cell: ({ value }) => {
        return value ? formatAsDollar(value.toFixed(2)) : "-";
      },
    },
    {
      Header: "Consumed Budget To Date",
      accessor: "consumedBudget",
      className: "text-center noSort",
      tdClassName: "text-left",
      thClassName: "text-center",
      disableSortBy: true,
      isTooltip: "Amount of budget utilized so far.",
      Cell: ({ value }) => {
        return value ? formatAsDollar(value.toFixed(2)) : "-";
      },
    },
    {
      Header: "Details",
      className: "text-center noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "text-center",
      isTooltip: "Additional information related to the budget entry.",
      Cell: ({ row }) => {
        return (
          <a
            title="Details"
            onClick={() => {
              infohandleShow({
                row
              });
            }}
            id="BudgetDetails_id"
          >
            <FaInfoCircle
              className="faInfoCircleStyle"
              size={15}
              data-bs-toggle="tooltip"
              data-bs-placement="left"
            />
          </a>
        );
      },
    },
    {
      Header: "Actions",
      className: "text-center noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "text-center",
      isTooltip: "Available options to manage or modify the record.",
      Cell: ({ row }) => {
        const isPastYear = isPastFiscalYear(row.original.financialYear);

        return (
          <div className="tdactions justify-content-center">
            <div className="actcol">
              <a title={isPastYear ? "Cannot edit past fiscal year" : "Edit"}>
                <FiEdit
                  className={`iconStyleActions ${isPastYear ? "disabled-link" : ""}`}
                  id={"BudgetEdit_id" + row.original.id}
                  onClick={isPastYear ? undefined : () => {
                    dispatch(getByIdBudget(row.original.id));
                    handleShow("Edit");
                  }}
                  style={{
                    cursor: isPastYear ? "not-allowed" : "pointer",
                    opacity: isPastYear ? 0.5 : 1
                  }}
                />
              </a>
            </div>
            <div className="actcol">
              <a title={isPastYear ? "Cannot delete past fiscal year" : "Delete"}>
                <FiTrash2
                  className={`iconStyleActions ${isPastYear ? "disabled-link" : ""}`}
                  id={"BudgetDelete_id" + row.original.id}
                  onClick={isPastYear ? undefined : () => {
                    deletehandleShow({ id: row.original.id, cmdbId: getCmdbId });
                  }}
                  style={{
                    cursor: isPastYear ? "not-allowed" : "pointer",
                    opacity: isPastYear ? 0.5 : 1
                  }}
                />
              </a>
            </div>
          </div>
        );
      }
    }


  ];

  const handleShow = (Action) => {
    setState({
      ...state,
      modalOpen: true,
      currentAction: Action
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
  };

  const deletehandleShow = (props) => {
    setState({
      ...state,
      deleteModal: true,
      deletepayload: props,
    });
  };
  const deletehandleClose = () => {
    setState({
      ...state,
      deleteModal: false,
      deletepayload: {},
    });
  };
  const infohandleShow = (props) => {
    setState({
      ...state,
      infoModal: true,
      infopayload: props,
    });
  };
  const infohandleClose = () => {
    setState({
      ...state,
      infoModal: false,
      infopayload: {},
    });
  };
  const handlePageLimitChange = (newPageLimit) => {
    setPageLimit(newPageLimit);
    setCurrentPageNo(0);
  };
  const handlePageNoChange = (pageNumber) => {
    if (pageNumber === 0) {
      setCurrentPageNo(0);
    } else {
      setCurrentPageNo(pageNumber);
    }
  };
  const onSearch = (e) => {
    setCurrentPageNo(0);
    setSearchInputValue(e);
  };
  const modalBody = () => (
    <>
      <AddBudget handleClose={handleClose} alertmsg={callAlert} open={state.modalOpen} reloadPayload={listPayload} currentAction={state.currentAction} />
    </>
  );
  const deleteModalBody = () => {
    return (
      <>
        <h4 className="delete-h">Budget Details</h4>
        {deleteLoadingBudget ? (
          <Spinners />
        ) : (
          <>
            <p>Are you sure you would like to delete the Budget Details?</p>
            <div className="btnswrap btn-dlt">
              <a
                type="submit"
                className="cancelBtnStyle btn btn-primary"
                onClick={deletehandleClose}
                id="BudgetCancel_id"
              >
                Cancel
              </a>
              <a
                type="submit"
                className="btnStyle btn btn-primary"
                id="BudgetDelete_id"
                onClick={() => {
                  deleteCall(state.deletepayload);
                }}
              >
                Delete
              </a>
            </div>
          </>
        )}
      </>
    );
  };
  const infoModalBody = () => {
    const data = state?.infopayload?.row?.original;
    const detailsTableData = [
      { header: 'Configured By', values: data?.createBy ? data.createBy : "-" },
      { header: 'Configured On', values: data?.createdDate ? convertEpochToDate(data.createdDate) : "-" },
      { header: 'Updated By', values: data?.updateBy ? data?.updateBy : "-" },
      { header: 'Updated On', values: data?.updatedDate ? convertEpochToDate(data.updatedDate) : "-" }
    ];
    return (
      <>
        <h4 className="schedule-tool m-0">Details</h4>
        <div>
          <DetailTable data={detailsTableData} />
        </div>
      </>
    );
  };
  // const btnData = [
  //   {
  //     text: "Add",
  //     btnClassName:"CloudBudgetNewPosition mr-0",
  //     btnComponent: (
  //       <>
  //         {/* <CommonBtn */}
  //         <ButtonComponent
  //           text="Add"
  //           onClick={() => handleShow("Add")}
  //           class="solid-btn btn btn-primary Addnewalignhower Addnewalign btnStyle m-0"
  //           // id = "Add_New_id"
  //           // disabled={(!actionRBAO)}
  //         />
  //       </>
  //     ),
  //   },
  // ];

  const btnData = [
    {
      text: "Add",
      btnComponent: (
        <>
          <CommonBtn
            name="Add"
            clickFunc={() => handleShow("Add")}
            btnStyle="icon-btn"
          //icon={<FaPlus className="cmdbImgIcon mx-1" />}
          />
        </>
      ),
    },
  ];

  const calculatedPageCount =
    ListBudget.totalCount ? Math.ceil(ListBudget.totalCount / pageLimit) : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
  const ListBudget1 = [
    {
      "createBy": "Krishnaprasad M",
      "updateBy": "Krishnaprasad M",
      "createdDt": "2025-02-18T13:02:02.988+00:00",
      "updateDt": "2025-02-18T13:02:02.988+00:00",
      "id": 210,
      "financialYear": "FY 24 (1st April 2024 to 31st March 2025)",
      "opexId": "ASAWD",
      "allocatedBudget": 5000.0,
      "createdDate": 1739883722,
      "updatedDate": 1739883722,
      "consumedBudget": 0.0,
      "budgetStartDate": 0,
      "budgetEndDate": 0,
      "budgetForMail": false,
      "effectiveDate": "01/2025"
    }
  ];
  return (
    <>
      <div className="dashcol bg-white mt-3">
        <div className="header-w-btn">
          <h4>Budget Details</h4>

        </div>

        <CompleteTableData
          isLoading={ListLoadingBudget}
          data={ListBudget.data ? ListBudget.data : []}
          // data={ ListBudget.result}
          columns={dataheader}
          marginUp={true}
          rowCondt={true}
          pageNo={pageNo}
          pageLimit={pageLimit}
          onPageLimitChange={handlePageLimitChange}
          listCount={ListBudget.totalCount ? ListBudget.totalCount : []}
          onPageNoChange={handlePageNoChange}
          curentPageNumber={currentPageNo}
          totalPageCount={finalPageCount}
          onSearch={onSearch}
          searchKey={searchInputValue}
          // tableClass="Gray_table"
          // isPagenation={true}
          // isSearch={true}
          // btnData={RoleConfig("Budget Details", "add", userRole)?btnData:null}
          btnData={btnData}
          moveSearchToEnd={true}

        />
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          closeBtn={true}
          closeBtnFuc={handleClose}
          size={"lg"}
        />
        <CustomModal
          modalOpen={state.deleteModal}
          modalBody={deleteModalBody}
          closeBtn={true}
          closeBtnFuc={deletehandleClose}
        />
        <CustomModal
          modalOpen={state.infoModal}
          modalBody={infoModalBody}
          closeBtn={true}
          closeBtnFuc={infohandleClose}
        />
        {/* <AlertBox
          alert={state.alert}
          type={state.alertType}
          message={state.alertMessage}
        /> */}
      </div>
    </>
  );
};
export default memo(BudgetDetails);